module.exports = __webpack_public_path__ + "sunsemweb/img/rain.4b90dd90.png";